import { render, staticRenderFns } from "./ItsSalesDepartDetailNew.vue?vue&type=template&id=0e144abf&scoped=true&"
import script from "./ItsSalesDepartDetailNew.vue?vue&type=script&lang=js&"
export * from "./ItsSalesDepartDetailNew.vue?vue&type=script&lang=js&"
import style0 from "./ItsSalesDepartDetailNew.vue?vue&type=style&index=0&id=0e144abf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e144abf",
  null
  
)

export default component.exports